<template>
    <div class='daudio'>
        <audio ref="audio" @timeupdate="updateProgress" @ended="end" @loadedmetadata="loadedmetadata" controls
            style="display: none" :src='fileUrl' preload="metadata">
            您的浏览器不支持音频播放
        </audio>
        <div class="audioBox">
            <div v-if="!isPlay" class="" @click="audioPlay(true)">
                <img src="@/assets/images/shop/icon8.png" class="img-s">
                <img src="@/assets/images/shop/icon17.gif" v-if="show" class="gif-s" @click="show = false">
            </div>
            <div v-else @click="audioPlay(false)">
                <img src="@/assets/images/shop/icon9.png" class="img-s">
            </div>
            <div class="scrubber-box">
                <div class="bg-s" :style="{ 'width': progress + '%' }">
                </div>
                <img src="@/assets/images/shop/icon10.png">
            </div>
            <div class="audioInfo">
                <p id="time">{{ countdown }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "AudioPlayer",
    data() {
        return {
            audio: null,
            contorl: null,
            contorlDot: null,
            contorlProgress: null,
            contorlProgressBox: null,
            current: "00:00",
            duration: "00:00",
            isPlay: false,
            progress: 0,
            countdown: '00:00',
            show: true
        };
    },
    props: {
        fileUrl: {
            type: String,
            default: ''
        }
    },
    created() { },
    mounted() {
        this.init()
    },
    methods: {
        pause() {
            this.audioPlay(false)
        },
        init() {
            this.audio = this.$refs.audio;
            this.contorl = this.$refs.contorl;
            this.audio.muted = true
            this.audio.play().then(() => this.audio.pause())
        },
        // 时分秒转换
        transTime(value) {
            let that = this;
            var time = "";
            var h = parseInt(`${value / 3600}`);
            value %= 3600;
            var m = parseInt(`${value / 60}`);
            var s = parseInt(`${value % 60}`);
            if (h > 0) {
                time = that.formatTime(h + ":" + m + ":" + s);
            } else {
                time = that.formatTime(m + ":" + s);
            }

            return time;
        },
        // 补零
        formatTime(value) {
            var time = "";
            var s = value.split(":");
            var i = 0;
            for (; i < s.length - 1; i++) {
                time += s[i].length === 1 ? "0" + s[i] : s[i];
                time += ":";
            }
            time += s[i].length === 1 ? "0" + s[i] : s[i];

            return time;
        },
        // 音频播放暂停
        audioPlay(status) {
            if (status) {
                this.audio.play();
                this.$emit('audioPlay', true)
            } else {
                this.audio.pause();
            }
            this.isPlay = status
        },
        // 更新进度条与当前播放时间
        updateProgress(e) {
            this.current = this.transTime(e.target.currentTime);
            this.progress = (e.target.currentTime / e.target.duration) * 100;
            this.countdown = this.transTime(e.target.duration - e.target.currentTime);
        },
        // 音频结束
        end(e) {
            this.isPlay = false
        },
        loadedmetadata(e) {
            this.duration = this.transTime(e.target.duration);
            this.audio.muted = false
            this.countdown = this.transTime(e.target.duration);

        }
    },
    activated() { },
};
</script>
<style lang="scss" scoped>
.audioBox {
    padding: 8px 16px;
    // background: #eaebed;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 1.39rem;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0rem 0.05rem 0.21rem 0rem rgba(100, 157, 250, 0.05);
    border-radius: 0.21rem;
    border: 0.01rem solid #EBECF0;
    position: relative;
}

.audioControls {
    width: 22px;
    height: 22px;
}

.audioInfo {
    h3 {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0.2px;
        text-align: justify;
        font-weight: 400;
        margin-bottom: 4px;
    }

    p {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        letter-spacing: 0.17px;
        text-align: justify;
        font-weight: 400;
    }
}

.scrubber {
    margin: 0 0.2rem;
    flex: 1;
    height: 5px;
    border-radius: 0.43rem;
    background: rgba(100, 157, 250, 0.2);
    position: relative;

    .progress {
        background: rgba(100, 157, 250, 1);
        border-radius: 0.43rem;
        height: 5px;
        position: absolute;
        top: 0px;
        left: 0px;
    }


}

.img-s {
    width: 0.8rem;
    height: 0.8rem;
}

.bg-s {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    background: linear-gradient(90deg, #5294FF 0%, #649DFA 51%, #1DD994 100%);
    height: 0.53rem;


}

.scrubber-box {
    flex: 1;
    background: #eee;
    position: relative;
    height: 0.53rem;
    margin: 0 0.16rem;

    img {
        height: 0.53rem;
        width: 100%;
        position: relative;
        z-index: 3;
        overflow: hidden;

    }
}

.gif-s {
    position: absolute;
    left: -0.32rem;
    bottom: -0.32rem;
    width: 2rem;
    z-index: 5;
}
</style>